import logo from 'assets/header-prevencor-xx.png';
import md5 from 'md5';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import QRCode from 'qrcode';
import fetchImageBase64 from 'utils/helpers';
import { pdfMakeGetBlob } from 'utils/pdfBlob';
import { buildValidacaoQrCodeUrl } from 'utils/validacaoQrCode';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

function buildBlocoAssinaturaDigital({ requisicao, qrCodeRequisicao }) {
  return {
    columns: [
      {
        width: 65,
        image: qrCodeRequisicao,
        fit: [58, 58],
        alignment: 'center',
      },
      {
        width: '*',
        margin: [6, 2, 0, 0],
        stack: [
          {
            text: `Documento assinado eletronicamente — Médico: Dr. ${requisicao?.NOMEMED || ''} - CRM: ${requisicao?.CRMMED || ''}`,
            bold: true,
            fontSize: 9,
            margin: [0, 0, 0, 2],
          },
          {
            text: `Autenticação: ${md5(JSON.stringify(requisicao || {}))}`,
            italics: true,
            fontSize: 8,
            margin: [0, 0, 0, 2],
          },
          {
            text: `VALIDADOR DE REQUISIÇÃO DIGITAL - PREVENCOR | CÓD. REQUISIÇÃO: ${requisicao?.CODREQUISICAO || ''} - CÓD. PACIENTE: ${requisicao?.CODPAC || ''}`,
            bold: true,
            fontSize: 8,
            margin: [0, 0, 0, 2],
          },
          {
            text: 'Aponte a câmera do celular para o QRCode e verifique a validade deste documento.',
            italics: true,
            fontSize: 7.5,
          },
        ],
      },
    ],
    margin: [0, 0, 0, 6],
  };
}

function buildLinhaCreditosPaginacao(currentPage, pageCount) {
  return {
    text: `Prevencor Marília — Página ${currentPage} de ${pageCount}`,
    alignment: 'center',
    fontSize: 7.5,
  };
}

export async function generateRequisicaoPdf({ requisicao }) {
  const logoBase64 = await fetchImageBase64(logo);

  const qrCodeRequisicao = await QRCode.toDataURL(
    buildValidacaoQrCodeUrl({
      tipo: 'requisicao',
      codDocumento: requisicao?.CODREQUISICAO,
      codPaciente: requisicao?.CODPAC,
    })
  );

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [40, 160, 40, 100],
    header: () => ({
      stack: [
        {
          image: logoBase64,
          width: 550,
          alignment: 'center',
          margin: [0, 0, 0, 0],
        },
        {
          text: 'REQUISIÇÃO DE EXAMES',
          style: 'header',
          alignment: 'center',
          margin: [0, 10, 0, 0],
        },

        {
          table: {
            widths: ['*'],
            body: [
              [
                {
                  stack: [
                    {
                      text: 'IDENTIFICAÇÃO DO SOLICITANTE',
                      bold: true,
                      margin: [0, 0, 0, 0],
                    },
                    {
                      text: `Médico: Dr. ${requisicao?.NOMEMED || ''}`,
                      margin: [0, 0, 0, 0],
                    },
                    {
                      text: `CRM: ${requisicao?.CRMMED || ''}`,
                      margin: [0, 0, 0, 0],
                    },
                    {
                      text: 'Endereço: RUA CLAUDIO MANOEL DA COSTA, 56 - BAIRRO MARIA IZABEL - MARÍLIA/SP - CEP 17515-460 - TELEFONE 14 3402-2700',
                      margin: [0, 0, 0, 0],
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 1,
            vLineWidth: () => 1,
            hLineColor: () => 'black',
            vLineColor: () => 'black',
          },
          margin: [50, 5, 50, 0],
        },
      ],
    }),
    content: [
      {
        text: requisicao?.DESCRICAO || '',
        margin: [30, 0, 30, 0],
        fontSize: 10,
      },
    ],
    styles: {
      header: { fontSize: 14, bold: true },
      subheader: { fontSize: 12, bold: true },
      footer: { italics: true },
    },
    footer: (currentPage, pageCount) => ({
      margin: [30, 8, 30, 0],
      fontSize: 8,
      stack: [
        buildBlocoAssinaturaDigital({ requisicao, qrCodeRequisicao }),
        buildLinhaCreditosPaginacao(currentPage, pageCount),
      ],
    }),
    defaultStyle: { fontSize: 11 },
  };

  return pdfMakeGetBlob(pdfMake.createPdf(docDefinition));
}
